import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5962efb5&scoped=true&lang=html&"
import script from "./pageNotFound.js?vue&type=script&lang=js&"
export * from "./pageNotFound.js?vue&type=script&lang=js&"
import style0 from "./pageNotFound.styl?vue&type=style&index=0&id=5962efb5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5962efb5",
  null
  
)

export default component.exports